import {
  FormPrimaryHeader,
  UserRegistrationForm,
  HighlightMessage
} from './styles';
import { Button, Icon } from '../../Universal/NovusDSImports';
import { btnStyles } from '../../Universal/NovusDSImports/variants';
import { STRINGS } from '../../Constants/ConstantStrings';
// import {
//   DEV_URL,
//   isProdInstance,
//   isUatInstance,
//   PROD_URL,
//   UAT_URL
// } from '../../settings';
import { useEffect } from 'react';
import PALoader from '../../SharedComponets/PALoader';
import { useReduxSelector, useReduxDispatch } from '../../Store/reduxHooks';
import { RootState } from '../../store';
import { getTermsAndConditions } from '../../Store/reducers/PublicView';
import { colorState } from '../../Universal/Foundation';
import DOMPurify from 'dompurify';
import { Helmet } from 'react-helmet';

interface TermsAndConditionsProps {
  onBack: () => void;
}

export default function TermsAndConditions({
  onBack
}: TermsAndConditionsProps) {
  const isFetchingTermsAndConditions = useReduxSelector(
    (state: RootState) => state.PublicView.isFetchingTermsAndConditions
  );

  const clientName = useReduxSelector(
    (state: RootState) => state.ClientInfo.client_name
  );

  const termsAndConditionsContent = useReduxSelector(
    (state: RootState) => state.PublicView.termsAndConditions
  );

  const dispatch = useReduxDispatch();

  useEffect(() => {
    dispatch(getTermsAndConditions({}));
  }, []);

  return (
    <>
      <Helmet>
        <title>{`${clientName} - Closures - Terms & Conditions`}</title>
      </Helmet>
      {isFetchingTermsAndConditions ? (
        <PALoader />
      ) : (
        <div
          className="container align-items-center justify-content-between"
          data-testid="termsAndConditionsPage"
        >
          <div className="gap-4 d-flex flex-column overflow-auto">
            <FormPrimaryHeader className="text-lg-nowrap">
              <div className="form-main-heading">
                {`${STRINGS.TERMS_AND_CONDITIONS}`}
              </div>
            </FormPrimaryHeader>
            <HighlightMessage>
              {`${STRINGS.THIS_PAGE_IS_FOR_TECHINICAL}`}
            </HighlightMessage>
            <UserRegistrationForm className="py-3">
              <div
                className="form-body gap-4 px-3 py-0"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    termsAndConditionsContent as string
                  )
                }}
              />
            </UserRegistrationForm>
          </div>
          <div>
            <Button
              {...btnStyles.secondary}
              onClick={onBack}
              data-testid="goBackToPreviousPageButton"
            >
              <Icon
                icon="arrow_narrow_left"
                stroke={`${colorState.icon.brand.primary}`}
              />
              {`${STRINGS.GO_BACK_TO_PREVIOUS_PAGE}`}
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
